<template>
  <div class="flex flex-column full-height relative pb3">
    <template v-if="routeMatchesComponent() && !contremarque">
      <div
        v-if="!loading"
        class="flex flex-column flex-auto full-height scrollable"
      >
        <div
          v-for="activity in activities"
          :key="activity"
          class="flex flex-wrap border-bottom mb1 white-bg col-12 full-height"
          style="height: 100px"
        >
          <div
            class="col-12 flex flex-wrap white bold full-height py1 px2"
            :class="
              activity.isReserved
                ? 'reserved'
                : activity.isFull
                  ? 'dark-grey-bg'
                  : 'reservable'
            "
          >
            <div class="col-6 flex flex-column justify-center">
              <div class="flex items-center">
                <div class="col-12 pr2 no-box">
                  <span class="block h5n bold">{{ activity.type }}</span>
                </div>
              </div>
            </div>

            <div class="col-6 flex flex-column justify-center items-end">
              <div
                v-if="!activity.isFull && activity.stock > 0"
                class="col-12 stock flex justify-end mb1"
              >
                <span
                  v-if="activity.stock > 1"
                  class="h6n"
                >{{ activity.stock }} places restantes
                </span>
                <span
                  v-if="activity.stock === 1"
                  class="h6n"
                >{{ activity.stock }} place restante
                </span>
              </div>

              <div
                v-else-if="activity.isFull"
                class="col-12 stock flex justify-end mb1"
              >
                <span class="h6n caps bold">complet</span>
              </div>

              <div class="col-12 flex justify-end">
                <div v-if="canShowEchangeButton(activity)">
                  <div 
                    v-if="activity.isExchangePossible"       
                    tabindex="0"
                    role="button"
                    class="reserve-btn py1 pointer no-box px1 white rounded darken-btn flex justify-center items-center"
                    :class="[
                      { 'disabled no-click' : (activity.max_amount && activity.reservations >= activity.max_amount) || activity.isFull }
                    ]"
                    @click="exchange(activity)"
                  >
                    <i
                      class="
                        h5n
                        icon icon-date-check-icon
                        line-height-3
                        icon-mr-1
                        bold
                      "
                    ></i>
                    <span class="h7n caps bold">Échanger</span>
                  </div>
                </div>
                <div
                  v-else-if="activity.isReservable || activity.isFull"
                  tabindex="0"
                  role="button"
                  class="
                    reserve-btn
                    py1
                    pointer
                    no-box
                    px1
                    white
                    rounded
                    darken-btn
                    flex
                    justify-center
                    items-center
                  "
                  :class="
                    (activity.max_amount &&
                      activity.reservations >= activity.max_amount) ||
                      activity.isFull
                      ? ' disabled no-click'
                      : ''
                  "
                  @click="reserve(activity)"
                >
                  <i
                    class="
                      h5n
                      icon icon-date-check-icon
                      line-height-3
                      icon-mr-1
                      bold
                    "
                  ></i>
                  <span class="h7n caps bold">Réserver</span>
                </div>

                <div
                  v-else-if="billetType !== 'single-session' && activity.isCancelable"
                  tabindex="0"
                  role="button"
                  class="
                    reserve-btn
                    py1
                    pointer
                    no-box
                    px1
                    white
                    rounded
                    darken-btn
                    flex
                    justify-center
                    items-center
                  "
                  :class="activity.isCancelable ? '' : ' disabled'"
                  @click="cancel(activity)"
                >
                  <i
                    class="
                      h5n
                      icon icon-not-check-icon
                      line-height-3
                      icon-mr-1
                      bold
                    "
                  ></i>
                  <span class="h7n caps bold">Annuler</span>
                </div>

                <div v-else-if="!(activity.isReservable || activity.isFull || activity.isCancelable)" class="col-12 right-align">
                  <h3 v-if="activity.isReservation" class="mt0 h6n mb1">L'annulation est impossible pour cette séance</h3>
                  <h3 v-else class="mt0 h6n mb1">Le délai d’annulation est dépassé</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="contremarque">
      <div class="flex h5 bold col-12 center justify-center">
        Pour réserver, vous devez activer votre e-billet. Veuillez vous rendre à l’accueil du centre.
      </div>
    </template>
  </div>
</template>
<script>
import { getCurrentInstance, computed, inject } from 'vue';
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';
import { routeIsCurrentComponent } from '@/mixins/utils';

export default {
  components: {},
  setup () {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());
    const contremarque = computed(() => store.state.contremarque);

    const cancel = inject('cancel');
    const reserve = inject('reserve');
    const exchange = inject('exchange');

    const loading = computed(() => store.state.loadingContent);

    const activities = computed(() => store.state.session?.activities || []);
    const billetType = computed(() => store.state.billetType);

    const isInternalSession = computed(() => store.state.siteInfo.is_internal_session || null);

    const canShowEchangeButton = (activity) => {
      if (isInternalSession.value) {
        return activity.inscription ? false : billetType.value === 'single-session' && (activity.isReservable || activity.isFull);
      }
      return billetType.value === 'single-session' && (activity.isReservable || activity.isFull)
    }

    onBeforeRouteLeave(() => {
      store.commit('setSession', null);
    });

    return {
      canShowEchangeButton,
      billetType,
      activities,
      router,
      route,
      store,
      loading,
      reserve,
      cancel,
      exchange,
      routeMatchesComponent,
      contremarque
    };
  }
};
</script>

<style lang="scss" scoped>
.action:hover .breadcrumb-arrow {
  color: white;
}
</style>
